import i18n from "./i18n.helper";
import i18nService from "../services/i18n.service";

/**
 * Język pełnego okna wizualizacji z parametru ?lang - wspólny dla /PublicSession i /Visualization.
 * Ładuje słownik języka i zwraca jego kod do ustawienia w $i18n.locale.
 */
export async function loadOwLanguage(languageCode) {
    const languageObj = await i18nService.setLocaleByLanguageCodeForOw(languageCode);
    const messageResult = await i18nService.geti18nMessages(languageObj.id);
    if (messageResult.status !== 200) {
        throw await Promise.reject(messageResult);
    }
    i18n.global.setLocaleMessage(languageObj.code, messageResult.data);
    return languageObj.code;
}
